/* Dabi Deri — mobil alt sekme çubuğu ve panelleri (sections/dabi-tabbar.liquid). Yalnız ≤ 749 px'te etkin.
   - html.has-dabi-tabbar: çubuk görünür; --dabi-tabbar-offset: çubuğun yüksekliği (sabit satın alma çubuğu bunun üstünde durur)
   - html.dabi-collect-floats: yüzen düğmeler gizli, "Daha fazla" panelinden açılır
   - html.dabi-tabbar-hidden: aşağı kaydırınca saklanır, yukarı kaydırınca / sayfa sonunda geri gelir
   - Paneller açıkken html.is-dabi-sheet (şerit okları ve yüzen ögeler çekilir), sayfa kaydırması kilitli */
(() => {
  const root = document.querySelector('[data-dabi-tabbar]');
  if (!root) return;
  const html = document.documentElement;
  const cfg = root.dataset;
  const bar = root.querySelector('.dabi-tabbar');
  const mq = window.matchMedia('(max-width: 749px)');
  const standalone = () => window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
  const appOnly = root.classList.contains('dabi-tabbar-root--app');
  const active = () => mq.matches && (!appOnly || standalone());
  const base = cfg.root || '/';
  const tick = () => { try { if (navigator.vibrate) navigator.vibrate(8); } catch (err) { /* yok */ } };

  /* ---------- görünürlük ve yükseklik ---------- */
  let hidden = false;
  const setOffset = () => {
    const on = html.classList.contains('has-dabi-tabbar') && !hidden;
    // yüzen kapsül: yükseklik + alttaki boşluk (güvenli alan dahil)
    const gap = on ? parseFloat(getComputedStyle(bar).bottom) || 0 : 0;
    html.style.setProperty('--dabi-tabbar-offset', on ? `${Math.round(bar.offsetHeight + gap)}px` : '0px');
  };
  const apply = () => {
    const on = active();
    html.classList.toggle('has-dabi-tabbar', on);
    html.classList.toggle('dabi-collect-floats', on && cfg.collect === 'true');
    if (!on) closeSheet(true);
    setOffset();
  };
  const setHidden = (h) => {
    if (hidden === h) return;
    hidden = h;
    html.classList.toggle('dabi-tabbar-hidden', h);
    setOffset();
  };
  let lastY = window.scrollY;
  window.addEventListener('scroll', () => {
    const y = window.scrollY;
    const d = y - lastY;
    lastY = y;
    if (cfg.hideScroll !== 'true' || !active() || openEl || html.classList.contains('is-dabi-sheet')) return;
    const nearEnd = window.innerHeight + y >= document.documentElement.scrollHeight - 48;
    if (d > 8 && y > 140 && !nearEnd) setHidden(true);
    else if (d < -8 || nearEnd || y < 60) setHidden(false);
  }, { passive: true });

  /* ---------- sayaçlar ---------- */
  const cartCount = root.querySelector('[data-tab-count="cart"]');
  const favCount = root.querySelector('[data-tab-count="fav"]');
  const setCount = (el, n) => {
    if (!el) return;
    const v = Number(n) || 0;
    if (String(v) !== el.textContent) {
      el.textContent = v > 99 ? '99+' : String(v);
      el.classList.remove('is-pop');
      void el.offsetWidth;
      if (v > 0) el.classList.add('is-pop');
    }
    el.hidden = v <= 0;
  };
  const readFavs = () => { try { return JSON.parse(localStorage.getItem('dabi-favs') || '[]') || []; } catch (err) { return []; } };
  const syncFav = () => setCount(favCount, readFavs().length);
  const syncCart = () => {
    const bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble span');
    setCount(cartCount, bubble ? parseInt(bubble.textContent, 10) || 0 : 0);
  };
  const cartIcon = document.getElementById('cart-icon-bubble');
  if (cartIcon) new MutationObserver(syncCart).observe(cartIcon, { childList: true, subtree: true, characterData: true });
  window.addEventListener('storage', (e) => { if (e.key === 'dabi-favs') syncFav(); });
  document.addEventListener('dabi:favs:changed', syncFav);
  // kalp düğmeleri (koleksiyon kartı, ürün sayfası, sepet) listeyi değiştirir
  document.addEventListener('click', (e) => {
    if (e.target.closest && e.target.closest('[data-pcard-fav], [data-dabi-fav], [data-pdp-fav], .dabi-pdp__fav, [data-dcart-fav]')) window.setTimeout(syncFav, 80);
  }, true);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) syncFav(); });

  /* ---------- paneller ---------- */
  const scrim = root.querySelector('[data-tabsheet-scrim]');
  let openEl = null;
  let lastTab = null;
  const markTab = (name) => {
    root.querySelectorAll('.dabi-tabbar__tab.is-open').forEach((t) => t.classList.remove('is-open'));
    if (name) root.querySelectorAll(`[data-tab="${name}"]`).forEach((t) => t.classList.add('is-open'));
  };
  function closeSheet(instant) {
    if (!openEl) return;
    const el = openEl;
    openEl = null;
    el.classList.remove('is-on');
    el.style.removeProperty('transform');
    if (scrim) scrim.classList.remove('is-on');
    html.classList.remove('is-dabi-sheet', 'dabi-tabsheet-open');
    markTab(null);
    window.setTimeout(() => {
      if (openEl !== el) el.hidden = true;
      if (!openEl && scrim) scrim.hidden = true;
    }, instant ? 0 : 340);
    if (lastTab && !instant) lastTab.focus({ preventScroll: true });
  }
  const openSheet = (name, from) => {
    const el = root.querySelector(`[data-tabsheet="${name}"]`);
    if (!el) return;
    if (openEl === el) { closeSheet(); return; }
    if (openEl) closeSheet(true);
    openEl = el;
    lastTab = from || null;
    setHidden(false);
    if (name === 'fav') renderFavs();
    if (name === 'more') tidyMore();
    if (scrim) scrim.hidden = false;
    el.hidden = false;
    html.classList.add('is-dabi-sheet', 'dabi-tabsheet-open');
    markTab(name === 'fav' ? 'favorites' : name);
    window.setTimeout(() => {
      if (openEl !== el) return;
      el.classList.add('is-on');
      if (scrim) scrim.classList.add('is-on');
      const x = el.querySelector('[data-tabsheet-close]');
      if (x) x.focus({ preventScroll: true });
    }, 20);
  };
  if (scrim) scrim.addEventListener('click', () => closeSheet());
  root.querySelectorAll('[data-tabsheet-close]').forEach((b) => b.addEventListener('click', () => closeSheet()));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && openEl) closeSheet(); });

  // aşağı çekerek kapat (tutamak ve başlık)
  root.querySelectorAll('[data-tabsheet]').forEach((el) => {
    let y0 = null;
    let dy = 0;
    const handles = el.querySelectorAll('[data-tabsheet-grab], .dabi-tabsheet__head');
    handles.forEach((h) => {
      h.addEventListener('pointerdown', (e) => {
        if (e.target.closest('button, a')) return;
        y0 = e.clientY;
        dy = 0;
        el.classList.add('is-drag');
        try { h.setPointerCapture(e.pointerId); } catch (err) { /* yok */ }
      });
      h.addEventListener('pointermove', (e) => {
        if (y0 === null) return;
        dy = Math.max(0, e.clientY - y0);
        el.style.transform = `translateY(${dy}px)`;
      });
      const end = () => {
        if (y0 === null) return;
        y0 = null;
        el.classList.remove('is-drag');
        if (dy > 90) closeSheet();
        else el.style.removeProperty('transform');
      };
      h.addEventListener('pointerup', end);
      h.addEventListener('pointercancel', end);
    });
  });

  /* ---------- favoriler paneli ---------- */
  const favList = root.querySelector('[data-favsheet-list]');
  const favEmpty = root.querySelector('[data-favsheet-empty]');
  const fmt = (cfg.moneyFormat || '{{amount}}').replace(/<[^>]*>/g, '');
  const group = (n, sep) => String(n).replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  const money = (cents) => {
    const v = (Number(cents) || 0) / 100;
    const [i, f] = v.toFixed(2).split('.');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
      if (k === 'amount_with_comma_separator') return `${group(i, '.')},${f}`;
      if (k === 'amount_no_decimals') return group(Math.round(v), ',');
      if (k === 'amount_no_decimals_with_comma_separator') return group(Math.round(v), '.');
      if (k === 'amount_with_apostrophe_separator') return `${group(i, "'")}.${f}`;
      return `${group(i, ',')}.${f}`;
    });
  };
  const HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.3s-7.3-4.4-8.9-9A4.9 4.9 0 0 1 12 6.9a4.9 4.9 0 0 1 8.9 4.4c-1.6 4.6-8.9 9-8.9 9Z"/></svg>';
  const pcache = new Map();
  const loadP = (h) => {
    if (!pcache.has(h)) pcache.set(h, fetch(`${base}products/${encodeURIComponent(h)}.js`, { headers: { Accept: 'application/json' } }).then((r) => (r.ok ? r.json() : null)).catch(() => null));
    return pcache.get(h);
  };
  let favToken = 0;
  async function renderFavs() {
    if (!favList) return;
    const mine = ++favToken;
    const handles = readFavs().slice(0, 40);
    favEmpty.hidden = handles.length > 0;
    favList.innerHTML = handles.map(() => '<li class="dabi-favsheet__item is-skel" aria-hidden="true"><span></span><span></span></li>').join('');
    if (!handles.length) return;
    const prods = await Promise.all(handles.map(loadP));
    if (mine !== favToken) return;
    favList.innerHTML = '';
    prods.forEach((p, i) => {
      if (!p) return;
      const li = document.createElement('li');
      li.className = 'dabi-favsheet__item';
      li.dataset.handle = handles[i];
      li.style.setProperty('--i', String(i));
      const src = p.featured_image ? `${p.featured_image}${p.featured_image.includes('?') ? '&' : '?'}width=240` : '';
      li.innerHTML = `<a class="dabi-favsheet__media" href="${p.url}">${src ? `<img src="${src}" alt="" width="240" height="240" loading="lazy">` : ''}</a><div class="dabi-favsheet__info"><a class="dabi-favsheet__title" href="${p.url}"></a><p class="dabi-favsheet__price"></p></div><button type="button" class="dabi-favsheet__rm" data-fav-rm>${HEART}</button>`;
      li.querySelector('.dabi-favsheet__title').textContent = p.title;
      const price = li.querySelector('.dabi-favsheet__price');
      price.textContent = p.price_varies ? `${money(p.price_min)} +` : money(p.price);
      if (p.available === false) price.classList.add('is-off');
      const rm = li.querySelector('[data-fav-rm]');
      rm.setAttribute('aria-label', cfg.labelRemove || '');
      rm.title = cfg.labelRemove || '';
      favList.appendChild(li);
    });
    if (!favList.children.length) favEmpty.hidden = false;
  }
  if (favList) favList.addEventListener('click', (e) => {
    const rm = e.target.closest('[data-fav-rm]');
    if (!rm) return;
    const li = rm.closest('[data-handle]');
    const h = li && li.dataset.handle;
    const next = readFavs().filter((x) => x !== h);
    try { localStorage.setItem('dabi-favs', JSON.stringify(next)); } catch (err) { /* yok */ }
    tick();
    li.classList.add('is-out');
    window.setTimeout(() => { li.remove(); if (!favList.children.length) favEmpty.hidden = false; }, 260);
    // sayfadaki kalpler de güncellensin
    document.querySelectorAll(`[data-handle="${CSS.escape(h)}"] [data-pcard-fav][aria-pressed="true"]`).forEach((b) => b.setAttribute('aria-pressed', 'false'));
    document.dispatchEvent(new CustomEvent('dabi:favs:changed', { detail: { handle: h } }));
  });

  /* ---------- daha fazla ---------- */
  const toast = (text) => {
    const t = document.createElement('div');
    t.className = 'dabi-tabtoast';
    t.setAttribute('role', 'status');
    t.textContent = text;
    document.body.appendChild(t);
    window.setTimeout(() => t.classList.add('is-on'), 20);
    window.setTimeout(() => { t.classList.remove('is-on'); window.setTimeout(() => t.remove(), 400); }, 2200);
  };
  const hasTarget = (kind) => {
    if (kind === 'install') return !standalone() && !!document.querySelector('[data-dabi-install]');
    if (kind === 'campaigns') { const h = document.querySelector('.dabi-camphub'); return !!(h && !h.classList.contains('dabi-camphub--desktop-only') && h.querySelector('[data-camphub-open]')); }
    if (kind === 'promise') { const s = document.querySelector('.dabi-scroll'); return !!(s && !s.classList.contains('dabi-scroll--no-mobile') && s.querySelector('[data-scroll-toggle]')); }
    return true;
  };
  function tidyMore() {
    root.querySelectorAll('[data-more]').forEach((li) => { li.hidden = !hasTarget(li.dataset.more); });
  }
  root.addEventListener('click', (e) => {
    const a = e.target.closest('[data-more-act]');
    if (!a) return;
    const kind = a.dataset.moreAct;
    tick();
    if (['whatsapp', 'account', 'link'].includes(kind)) return; // olağan bağlantı
    e.preventDefault();
    closeSheet(true);
    window.setTimeout(() => {
      if (kind === 'search') openSearch(a.getAttribute('href'));
      else if (kind === 'favorites') openSheet('fav');
      else if (kind === 'campaigns') { const b = document.querySelector('[data-camphub-open]'); if (b) b.click(); }
      else if (kind === 'promise') { const b = document.querySelector('[data-scroll-toggle]'); if (b) b.click(); }
      else if (kind === 'install') {
        const host = document.querySelector('[data-dabi-install]');
        if (host) { host.hidden = false; const b = host.querySelector('[data-dabi-install-open]'); if (b) b.click(); }
      } else if (kind === 'share') {
        const data = { title: document.title || cfg.shareTitle, url: window.location.href };
        if (navigator.share) navigator.share(data).catch(() => {});
        else if (navigator.clipboard) navigator.clipboard.writeText(data.url).then(() => toast(cfg.labelCopied || '✓')).catch(() => {});
      }
    }, 60);
  });

  /* ---------- sekmeler ---------- */
  function openSearch(href) {
    const d = document.querySelector('.dabi-search > details');
    if (!d) { window.location.href = href || `${base}search`; return; }
    if (!d.open) { const s = d.querySelector('summary'); if (s) s.click(); else d.open = true; }
    window.setTimeout(() => { const i = d.querySelector('input[type="search"], input'); if (i) i.focus(); }, 120);
  }
  root.addEventListener('click', (e) => {
    const t = e.target.closest('[data-tab]');
    if (!t) return;
    const kind = t.dataset.tab;
    tick();
    if (kind === 'home' || kind === 'link' || kind === 'account') return; // olağan bağlantı
    e.preventDefault();
    if (kind === 'favorites') { openSheet('fav', t); return; }
    if (kind === 'more') { openSheet('more', t); return; }
    closeSheet(true);
    if (kind === 'search') { openSearch(t.getAttribute('href')); return; }
    if (kind === 'categories') {
      const d = document.querySelector('.dabi-header__mobile-menu');
      if (!d) { window.location.href = `${base}collections`; return; }
      if (!d.open) { const s = d.querySelector('summary'); if (s) s.click(); else d.open = true; }
      return;
    }
    if (kind === 'cart') {
      const drawer = document.querySelector('cart-drawer');
      if (drawer && drawer.dataset.iconAction !== 'page' && typeof drawer.open === 'function') drawer.open(t);
      else window.location.href = cfg.cartUrl || `${base}cart`;
    }
  });

  // başka bir alttan panel (ürün rafı, kategori şeridi) açılınca çubuk geri gelir; panel çubuğun üstünde durur
  new MutationObserver(() => {
    if (html.classList.contains('is-dabi-sheet') && hidden) setHidden(false);
  }).observe(html, { attributes: true, attributeFilter: ['class'] });

  // mobil menü açıkken "Kategoriler" sekmesi vurgulu
  const mmenu = document.querySelector('.dabi-header__mobile-menu');
  if (mmenu) mmenu.addEventListener('toggle', () => {
    if (openEl) return;
    root.querySelectorAll('[data-tab="categories"]').forEach((t) => t.classList.toggle('is-open', mmenu.open));
    if (mmenu.open) setHidden(false);
  });

  // başka bileşenler (mobil menü) panelleri açabilsin
  window.DabiTabbar = { open: (name) => openSheet(name), close: () => closeSheet() };

  /* ---------- başlat ---------- */
  apply();
  syncFav();
  syncCart();
  mq.addEventListener ? mq.addEventListener('change', apply) : mq.addListener(apply);
  window.addEventListener('resize', setOffset, { passive: true });
  window.addEventListener('load', setOffset);
  document.addEventListener('shopify:section:load', (e) => { if (e.target.contains(root)) apply(); });
})();
